// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { loadSites } from '../../actions/actions';
import Article from 'grommet/components/Article';
import Header from 'grommet/components/Header';
import Map from './Map';
import Section from 'grommet/components/Section';
import Footer from 'grommet/components/Footer';

import NavControl from '../NavControl';


import { navEnable } from '../../actions/nav';


class Dashboard extends Component {

  constructor(props) {
    super(props);
  }
  componentWillMount() {

    this.props.dispatch(loadSites());
    this.props.dispatch(navEnable(true));
  }


  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {

  }

  componentWillUnmount() {
    // this.props.dispatch(unloadDashboard());
    // this._graphicSizer.stop();
  }


  render() {
    if(this.props.userProfile) {
      //console.log(this.props.userProfile.username);
      heap.identify(this.props.userProfile.username);
    }
    return (
      <Map />
    );
  }

}

Dashboard.propTypes = {
  dashboard: PropTypes.object,
  search: PropTypes.object
};

let select = (state, props) => ({
  dashboard: state.dashboard,
  userProfile: state.user.profile
});

export default connect(select)(Dashboard);



// WEBPACK FOOTER //
// ./src/js/components/dashboard/Dashboard.js